import React, { Component } from 'react';
// import TagManager from 'react-gtm-module';

import Switch  from '@material-ui/core/Switch';
import GrupoOpcoes from '../childrens/confOpcoesRecebimentoLista/.mixins/confOpcoesRecebimentoLista';
import { Helmet } from 'react-helmet';

import Cookies from "universal-cookie";
import Alerta from "../../../../../util/snackbars/.mixins/";

import OpcoesRecebimentoGrupoCondicoes from '../../../../../../controllers/opcoesRecebimentoGrupoCondicoes';
import Config from '../../../../../../controllers/config';

export default class OpcoesRecebimentoGrupoCondicoess extends Component {
    
    constructor(props) {
        super(props);
        
        this.child = React.createRef();

        this.state = {
            itens: [],
            title: "Condições ativas no grupo",
            isLoading: true,
            isError: false,
            error: null
        }

        this.setState = this.setState.bind(this);
        this.handlerSwitch = this.handlerSwitch.bind(this);

    }

    UNSAFE_componentWillMount() {
        //carregamento de dados nos campos
        this.loadData(null);
    }

    componentDidMount() {
        // TagManager.dataLayer({
        //     dataLayer: {
        //       event: 'event',
        //       eventCategory: 'tokstok:fornecedores:conf-opcoes-recebimento',
        //       eventAction: 'componentDidMount',
        //       eventLabel: 'componente-conf-opcoes-recebimento',
        //     }
        // });
    }

    renderAtivo = ({codigo,value}) => {
        return (
            <div>
                <Switch
                    size="small" 
                    value={codigo}
                    checked={value}
                    tabIndex={-1}
                    disableRipple
                    onClick={()=>{this.handlerCheck(codigo)}}
                />
            </div>
        );
    };

    handlerCheck(codigo) {
        let itens = this.state.itens;
        let check = true;
        
        itens.forEach(e => {
            e.Array.forEach(x => {
                if (x.ATIVO.codigo == codigo.toString()) {
                    check = x.ATIVO.value;
                    x.ATIVO.value = x.ATIVO.value ? false : true;
                }
            });
        });

        this.setState({itens});

        this.handlerSwitch(this,codigo,check);
    };

    async handlerSwitch(props,codigo,check) {

        const cookies = new Cookies();
        const token = cookies.get('User-Token');
        
        try {
            const body = {
                id_org: this.props.params.id,
                id_cond_tcc: codigo,
                in_ativar: check ? 'N': 'S',
            };

            const params = JSON.stringify(body);
            let o_auth = await OpcoesRecebimentoGrupoCondicoes.PostOpcaoReceb(params,token);
            let j_auth = JSON.parse(o_auth.body);

            if (o_auth.res.statusCode === 200) {
                if(check){
                    props.child.current.retorno('Removido associação com sucesso!','success');
                }else {
                    props.child.current.retorno(j_auth.message,'success');
                }
            } else {
                if (j_auth && j_auth.message) {
                    throw new Error(j_auth.message);
                } else {
                    throw new Error("Não foi possível efetuar a associação!");
                }
            }
        } catch (error) {
            let errorString = "Não foi possível efetuar a associação!";
            if (Config.DEBUG === "TRUE")
                errorString = error.message;
            this.child.current.retorno(errorString,'error');
        }

    }

    async loadData(props) {
        const cookies = new Cookies();
        const token = cookies.get('User-Token');
        const filters = {
            idOrg: this.props.params.id
        };

        try {
            const o_condicoes = await  OpcoesRecebimentoGrupoCondicoes.get(token, filters);
            let j_condicoes = JSON.parse(o_condicoes.body);

            j_condicoes.forEach(x => {
                x.Array = x.Array.map(e => {
                    return {
                        ...e,
                        ATIVO: {
                            codigo: e.CD_PAGTO,
                            value: (e.IN_ATIVO === "S")
                        },

                        DESCRICAO: e.VP_DESC_ANTEC_PAGTO ? `${e.NR_PRAZO} dias após a entrega, desconto de ${e.VP_DESC_ANTEC_PAGTO }%` : `${e.NR_PRAZO} dias após a entrega`
                    };
                });
            });

            if (o_condicoes.res.statusCode == 200) {
                const erroString = 'Condições ativas no grupo';

                this.setState({
                    title: erroString,
                    itens: j_condicoes,
                    isLoading: false,
                });

                // TagManager.dataLayer({
                //     dataLayer: {
                //       event: 'event',
                //       eventCategory: 'tokstok:fornecedores:conf-opcoes-recebimento',
                //       eventAction: 'callback',
                //       eventLabel: `sucesso:${erroString}`,
                //     }
                // });
            } else {
                if (
                    j_condicoes.status == false && 
                    j_condicoes.message && 
                    j_condicoes.message.includes("Token inválido!")
                ) {
                    this.child.current.retorno('Autentificação inválida!','error');
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                } else {
                    throw new Error("Campos necessários, não foram retornados pelo servidor!");
                }
            }
        } catch (error) {
            this.child.current.retorno('Erro ao carregar dados!','error');
            let errorString = "Erro ao carregar dados!";
            if (Config.DEBUG === "TRUE"){
                errorString = error.message;
            }
            this.setState({
                isError: true,
                isLoading: false,
                error: errorString
            });

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:conf-opcoes-recebimento',
            //       eventAction: 'callback',
            //       eventLabel: `erro:${error.message}`,
            //     }
            // });
        }

    }

    render() {
        return(
            <div>
                <Helmet>
                    <title>{`${process.env.REACT_APP_TITLE} -  Grupos opções recebimento`}</title>
                </Helmet>
                <GrupoOpcoes {...this}/>
                <Alerta ref={this.child}/>
            </div>
        );
    }
}
